<template>
  <v-container :fluid="true" class="page_container">
    <div class="mail__title">
      <span class="mail__title--text" v-if="!search_panel && $vuetify.display.width < 769 || $vuetify.display.width >= 769">
        Все уведомления от партнеров
      </span>
      <div v-if="search_panel" class="search__field">
        <v-text-field
            v-model="search_local_value"
            @keydown.enter="clickSearch"
            ref="search-field-input"
            class="search__field_input"
            color="#3254B9"
            base-color="#313743"
            variant="outlined"
            placeholder="Введите текст и нажмите кнопку поиска"
        >
          <template v-slot:label>
            <div class="search__field_label">
              Поиск
            </div>
          </template>
          <template v-slot:append>
            <div class="search__field_label" @click="closeSearch" style="cursor: pointer">
              <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
            </div>
          </template>
          <template v-slot:append-inner>
            <v-icon size="20" class="search_icon" @click="clickSearch" v-if="$vuetify.display.mdAndDown">$custom_search</v-icon>
          </template>
        </v-text-field>
      </div>
      <v-icon :size="$vuetify.display.width >= 769 ? 30 : 20" class="search_icon" @click="openSearch" v-else>$custom_search</v-icon>
    </div>
    <div
        class="mail__content"
    >
<!--      <span class="text-red">{{mails.length}}</span>-->
      <MailCard
        v-if="mails.length > 0 && !isLoadingMails"
        :mails="filteredMails"
        justify_row="space-around"
      />
      <div v-else-if="mails.length === 0 && !isLoadingMails">
        <NoData/>
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
      <div v-if="isLoadingMails">
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import MailCard from "@/modules/templates/MailCard.vue"
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin"
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "Partners",
  components: {
    NoData,
    MailCard,
    FulfillingSquareSpinner
  },
  mixins: [PaginatedDataMapperMixin],
  data () {
    return {
      isLoading: true,
      // isSubLoading: false,
      covers: {},
      search_panel: false,
      search: {
        parameter: 'search',
      },
      search_local_value: undefined,
    }
  },
  computed: {
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      mails: 'personal_account/mails/getMails',
      count: 'personal_account/mails/getMailsCount',
      isLoadingMails: 'personal_account/mails/isLoadingMails',
    }),
    filteredMails () {
      return this.mails.filter(el => {
        return el.subject?.toLowerCase().includes(this.search_local_value?.toLowerCase()) || !this.search_local_value
      })
    }
  },
  methods: {
    ...mapActions({
      load: 'personal_account/mails/loadMails',
    }),
    loadData (url = undefined) {
      return new Promise(resolve => {
        this.load({
          url: url,
          finalizer: (data, url) => {
            this.setCurrentLoadUrl(url)
            resolve()
          },
          catcher: () => {}
        })
      })
    },
    clickSearch () {},
    openSearch () {
      this.search_panel = true
      this.loadData().then(() => {
        this.$nextTick(() => {
          this.$refs['search-field-input'].focus()
        })
      })
    },
    closeSearch () {
      this.search_panel = false
      this.search.value = ''
      this.$nextTick(() => {
        this.loadData()
      })
    }
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      this.loadData()
    }
  }
})
</script>

<style scoped lang="scss">
.mail__title {
  display: flex;
  justify-content: space-between;
}

.mail__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.search__field {
  margin-top: -10px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  width: 500px;
}

.search__field_input {
  height: 50px;
}

.search__field_label {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
}

.search_icon {
  cursor: pointer;
}

.mail__content {
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 25px 25px;
}

.mail__next {
  padding-top: 25px;
  padding-bottom: 25px;
}

.mail__next_btn {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

@media screen and (max-width: 1280px) {
  .mail__content {
    padding: 0;
  }
}

@media screen and (max-width: 768px) {
  .mail__title {
    margin-top: 20px;
  }

  .mail__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .search__field_input {
    height: 70px;
  }

  .search__field_label {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
